import { c as _c } from "react/compiler-runtime";
import { Heading, Stack, Text } from '@chakra-ui/react';
import type { ScoProduct } from '@src/graphql-types';
import { isRecommendedProduct, orderProductsForIntent, resolvePaywallIntent, type PaywallIntentId } from './intent';
import { productLabel, productPaywallIntent, productPriceLabel } from './presentation';
export type PaywallHeroProps = {
  products: ScoProduct[];
  intent?: PaywallIntentId;
  tokens?: Record<string, string>;
  showPlanSummary?: boolean;
};
export const PaywallHero = t0 => {
  const $ = _c(8);
  const {
    intent,
    products,
    showPlanSummary: t1,
    tokens
  } = t0;
  const showPlanSummary = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== intent || $[1] !== products || $[2] !== showPlanSummary || $[3] !== tokens) {
    const resolved = resolvePaywallIntent(intent, tokens);
    const lead = orderProductsForIntent(products, resolved)[0];
    const leadIsRecommended = lead ? isRecommendedProduct(lead, resolved) : false;
    const copy = lead ? productPaywallIntent(lead, intent, tokens) : resolved;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        base: 2,
        md: 3
      };
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        base: "3xl",
        md: "4xl"
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        base: "md",
        md: "lg"
      };
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t2 = <Stack gap={t3} maxW="3xl"><Heading as="h1" fontWeight="extrabold" letterSpacing="-0.03em" lineHeight="shorter" size={t4} textWrap="balance">{copy.headline}</Heading><Text color="fg.muted" maxW="60ch" textStyle={t5} textWrap="pretty">{copy.supporting}</Text>{lead && showPlanSummary ? <Text textStyle="sm">{leadIsRecommended ? "Recommended plan: " : "Plan: "}<Text as="span" fontWeight="semibold">{`${productLabel(lead)}, ${productPriceLabel(lead)}`}</Text></Text> : null}</Stack>;
    $[0] = intent;
    $[1] = products;
    $[2] = showPlanSummary;
    $[3] = tokens;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};